module.exports = __webpack_public_path__ + "img/JapanIcon.e9c0179.webp";